module.exports = __webpack_public_path__ + "officialStatic/img/case2.ad01112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case2.png
// module id = 7zAc
// module chunks = 0